import { render, staticRenderFns } from "./DeleteFilterDialog.vue?vue&type=template&id=a50ff516&scoped=true&"
import script from "./DeleteFilterDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteFilterDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ff516",
  null
  
)

export default component.exports